export default __webpack_public_path__ + "static/media/warning_icon_big.cd44ae1d.svg";